import {
  MARKERS_INERT_CLASS,
  MARKERS_INERT_STYLE_ID,
  OUTLINE_COLOR,
  VERTEX_FILL,
} from './drawingConstants';

// The single committed shape the layer is currently editing, tagged by kind so
// readers know which google.maps overlay type the shape actually is.
export type CommittedShape =
  | { kind: 'circle'; shape: google.maps.Circle }
  | {
      kind: 'polygon' | 'linestring';
      shape: google.maps.Polygon | google.maps.Polyline;
    };

export const latLngToLiteral = (
  ll: google.maps.LatLng,
): google.maps.LatLngLiteral => ({
  lat: ll.lat(),
  lng: ll.lng(),
});

export const pathToLiterals = (
  path: google.maps.MVCArray<google.maps.LatLng>,
): google.maps.LatLngLiteral[] => path.getArray().map(latLngToLiteral);

// Inject (once) the CSS that makes data markers inert while grabbing, so the
// grab click falls through to the map.
export const ensureMarkersInertStyle = () => {
  if (document.getElementById(MARKERS_INERT_STYLE_ID)) {
    return;
  }

  const style = document.createElement('style');
  style.id = MARKERS_INERT_STYLE_ID;
  style.textContent =
    `.${MARKERS_INERT_CLASS} gmp-advanced-marker,` +
    `.${MARKERS_INERT_CLASS} gmp-advanced-marker * {` +
    'pointer-events: none !important;' +
    '}';
  document.head.appendChild(style);
};

// Display-only dot at a placed vertex
export const makeVertexDot = (): HTMLDivElement => {
  const dot = document.createElement('div');
  dot.style.cssText =
    'width:10px;height:10px;border-radius:50%;box-sizing:border-box;' +
    `background:${VERTEX_FILL};border:1px solid ${OUTLINE_COLOR};` +
    // AdvancedMarker anchors content bottom-centre at the point; nudge down
    // half the height so the dot is centred on the vertex.
    'transform:translateY(50%);pointer-events:none;';
  return dot;
};
